import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NotebookPen, ChevronDown, ChevronUp } from "lucide-react";
import api from "../lib/api";
import { ukDate } from "../lib/dates";

export const MySermonNotes = () => {
  const [notes, setNotes] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/sermons/notes/mine").then(({ data }) => setNotes(data)).catch(() => {}); }, []);
  if (!notes.length) return null;
  return (
    <div data-testid="my-sermon-notes" className="bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)] p-6">
      <div className="flex items-center justify-between">
        <h3 className="font-head text-lg font-bold flex items-center gap-2"><NotebookPen className="h-5 w-5" style={{ color: "var(--sj-primary)" }} /> My Sermon Notes</h3>
        <Link to="/sermons" data-testid="my-sermon-notes-all" className="text-sm font-semibold" style={{ color: "var(--sj-primary)" }}>Sermon library</Link>
      </div>
      <ul className="mt-3 divide-y divide-[#EBE9E4]">
        {notes.slice(0, 6).map((n) => (
          <li key={n.sermon_id} className="py-3">
            <button data-testid={`my-sermon-note-${n.sermon_id}`} onClick={() => setOpen(open === n.sermon_id ? null : n.sermon_id)} className="w-full flex items-start justify-between gap-3 text-left">
              <span className="min-w-0">
                <span className="block font-semibold truncate">{n.title}</span>
                <span className="block text-xs" style={{ color: "var(--sj-text-3)" }}>{[n.speaker, n.series, n.sermon_date && ukDate(n.sermon_date)].filter(Boolean).join(" · ")}</span>
              </span>
              {open === n.sermon_id ? <ChevronUp className="h-4 w-4 shrink-0 mt-1" /> : <ChevronDown className="h-4 w-4 shrink-0 mt-1" />}
            </button>
            <p className={`text-sm mt-1.5 whitespace-pre-wrap break-words ${open === n.sermon_id ? "" : "line-clamp-2"}`} style={{ color: "var(--sj-text-2)" }}>{n.body}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
